<template>
  <div class="customer-profile">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'customers_list'}" class="float-left mr-1 main-link">{{$t('customer.customer')}}</router-link> / {{$t('customer.detail')}}
                </h3>
              </strong>
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="row">
        <div class="col-sm-3">
          <div class="row">
            <b-col cols="12">
              <b-card class="header mb-0" header-tag="header" footer-tag="footer">
                <div slot="header">
                  <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('customer.basic_information') }}</strong>
                  <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus" v-b-toggle.basic_information_content>
                    <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                    <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
                  </label>
                </div>
                <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
                  <div class="m-auto text-center">
                    <img src="../../../../static/img/avatars/default.jpg" width="150"/>
                    <p class="text-profile" v-if="$session.get('lang') == 'ja'">
                      {{customerInfo.last_name}}{{customerInfo.first_name}}
                    </p>
                    <p class="text-profile" v-else>
                      {{customerInfo.first_name}} {{customerInfo.last_name}}
                    </p>
                    <p class="text-left">
                      <span class="bold">{{$t('customer.email')}}:</span>
                      {{ (customerInfo.emails && customerInfo.emails.length > 0) ? _.map(customerInfo.emails, 'email').join(', ') : customerInfo.email}}
                    </p>
                    <p class="text-left">
                      <span class="bold">{{$t('customer.phone')}}:</span> {{customerInfo.phone}}
                    </p>
                    <p class="text-left" v-if="config && config.config.show_point">
                      <span class="bold">{{$t('customer.point')}}:</span> {{customerInfo.point}}
                    </p>
                    <p class="text-left" v-if="customerInfo.client === 2">
                      <span class="bold">{{$t('customer.token_balance')}}:</span> {{customerInfo.remaining_tickets}}
                    </p>
                    <p class="text-left" v-if="customerInfo.client === 2">
                      <span class="bold">{{$t('customer.total_token_used')}}:</span> {{customerInfo.game_play_count}}
                    </p>
                  </div>
                  <div class="row">
                    <button class="btn btn-action-view bg-main w-100" @click="editCustomer"> {{$t("customer.edit_profile")}}</button>
                  </div>
                  <div class="row">
                    <button class="btn btn-action-view bg-main w-100" @click="editMemberShip">&nbsp;{{convertMemberNameMemberShip(this.currentMembershipName || null )}}&nbsp;</button>
                  </div>
                  <div class="row">
                    <button class="btn btn-action-view bg-main w-100" @click="assign_coupon"> {{$t("customer.assign_coupon")}}</button>
                  </div>
                  <div class="row" v-if="config && config.config.show_point">
                    <button class="btn btn-action-view bg-main w-100" @click="export_customer_data"> {{$t("customer.export_customer_data")}}</button>
                  </div>                  
                  <div class="row">
                    
                    <!-- basic Info -->
                      <vue-json-to-csv  ref ="basicInfoElement"
                              :json-data="exportCustomerBasicInfoToCSV.data" 
                              :csv-title="'customer_' + this.customerInfo.email + '_' + this.$moment().format('YYYY-MM-DD')"
                              :labels="exportCustomerBasicInfoToCSV.fields"
                              style='display:none;' >                     
                      </vue-json-to-csv>
                       <!-- shipping address details -->
                      <!-- <vue-json-to-csv ref ="shippingAddressElement"
                              :json-data="exportShippingAddressToCSV.data" 
                              :csv-title="exportShippingAddressToCSV.fileName"
                              :labels="exportShippingAddressToCSV.fields"
                              style='display:none;'>                     
                      </vue-json-to-csv> -->
                      <!-- order details -->
                      <vue-json-to-csv  ref ="orderElement"
                              :json-data="exportOrdersToCSV.data" 
                              :csv-title="'customer_' + this.customerInfo.email + '_' + this.$moment().format('YYYY-MM-DD')"
                              :labels="exportOrdersToCSV.fields"
                              style='display:none;'>                     
                      </vue-json-to-csv>
                       <!-- coupon details -->
                      <!-- <vue-json-to-csv ref ="couponElement"
                              :json-data="exportCouponsToCSV.data" 
                              :csv-title="exportCouponsToCSV.fileName"
                              :labels="exportCouponsToCSV.fields"
                              style='display:none;'>                     
                      </vue-json-to-csv> -->
                  </div>
                  <div class="row">
                    <b-button size="sm" variant="success" class="btn btn-action-view w-100" @click="enableCustomer" v-if="customerInfo.status != 1">
                      <i class="fa fa-check "></i>  {{$t('common.active')}}
                    </b-button>
                    <b-button size="sm" variant="danger" class="btn btn-action-view w-100" @click="disableCustomer" v-else>
                      <i class="fa fa-trash-o "></i>  {{$t('common.inactive')}}
                    </b-button>

                  </div>
                  <div class="row">
                    <b-button size="sm" variant="danger" class="btn btn-action-view w-100" @click="deleteCustomer" >
                      <i class="fa fa-trash-o "></i>  {{$t('customer.customer_data')}}
                    </b-button>

                  </div>
                </b-collapse>
                <div slot="footer">
                  <button type="button" class="btn border-radius-4px bg-main float-left ml-4" @click="$router.push({name: 'customers', query: {rollback: 1}})"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
                </div>
              </b-card>
            </b-col>
          </div>
        </div>
        <div class="col-sm-9">
          <div class="row">
            <b-col cols="12">
              <b-card class="header mb-0" header-tag="header" footer-tag="footer">
                <div slot="header">
                  <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('customer.shipping_address') }}</strong>
                  <label class="switch switch-sm switch-text switch-info float-right" @click="updateLocationStatus" v-b-toggle.location_content>
                    <i class="fa fa-sort-down" v-if="locationStatus"></i>
                    <i class="fa fa-sort-up" v-if="!locationStatus"></i>
                  </label>
                </div>
                <b-collapse :visible.sync="locationStatus" id="location_content">
                  <div v-for="(location,i) in customerInfo.locations" :key="i+0">
                    <div class="form-group row" >
                      <legend class="col-sm-2 col-form-label"><strong>{{$t('customer.address')}} {{i+1}}: </strong></legend>
                      <div class="col-sm-5">
                        <legend v-if="config && config.config.show_full_address" class="col-form-label">{{location.display_address}}</legend>
                        <legend v-else class="col-form-label">{{`${location.localization_address} ${location.house_no} ${location.landmark} ${location.unit_no ? `${$t('customer.room')} ${location.unit_no}` : ''}`}}</legend>
                      </div>
                      <div class="col-sm-5">
                        <button class="btn btn-green" @click="editAddressPopup(location)" >{{$t('common.edit')}}</button>
                      </div>
                    </div>
                    <hr>
                  </div>
                </b-collapse>
              </b-card>
            </b-col>
          </div>
          <b-row>
            <b-col cols="12">
              <b-card header-tag="header" footer-tag="footer">
                <div slot="header">
                  <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('order.orders') }}</strong>
                  <label class="switch switch-sm switch-text switch-info float-right" @click="updateOrdersStatus" v-b-toggle.orders_content>
                    <i class="fa fa-sort-down" v-if="ordersStatus"></i>
                    <i class="fa fa-sort-up" v-if="!ordersStatus"></i>
                  </label>
                </div>
                <b-collapse :visible.sync="ordersStatus" id="orders_content">
                  <b-col cols="12" class="text-center">
                    <b-row>
                      <b-col cols="2">
                        <div class="pull-left mr-4">
                          <b-input-group v-bind:prepend="$t('order.status')">
                            <b-form-select v-model="filter.status" v-bind:value="filter.status" :options="statuses[$session.get('lang')]" v-bind:placeholder="$t('order.status')">
                            </b-form-select>
                          </b-input-group>
                        </div>
                      </b-col>
                      <b-col cols="3">
                        <div class="pull-left mr-4">
                          <b-input-group v-bind:prepend="$t('order.order_type')">
                            <b-form-select v-model="filter.order_type" v-bind:value="filter.order_type" :options="order_types[$session.get('lang')]" v-bind:placeholder="$t('order.order_type')">
                            </b-form-select>
                          </b-input-group>
                        </div>
                      </b-col>
                      <b-col cols="3">
                        <div class="pull-left mr-4">
                          <b-input-group v-bind:prepend="$t('order.show_late_delivery')">
                            <b-form-select v-model="filter.late_delivery" v-bind:value="filter.late_delivery" :options="late_delivery_statuses[$session.get('lang')]" v-bind:placeholder="$t('order.show_late_delivery')">
                            </b-form-select>
                          </b-input-group>
                        </div>
                      </b-col>
                      <b-col cols="4">
                        <b-input-group>
                          <select-dropdown v-bind:options="filter.options" v-bind:selected="filter.selected" position="prepend" v-bind:all="false" v-model="field" prefix="order">
                          </select-dropdown>
                          <input type="text" class="form-control" v-model="key" v-on:keydown.enter="refreshData"/>
                          <div class="input-group-append">
                            <b-input-group-append>
                              <b-btn @click="refreshData()"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>
                            </b-input-group-append>
                          </div>
                        </b-input-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <div class="table-responsive">
                        <table class="table table-striped table-hover table-sm header-pointer">
                          <thead>
                          <tr>
                            <th scope="col" v-for="item in dataTable.fields" :key="item.id" @click="updateSort(item.name)" v-show="checkShowByConfig(item.name)">
                              <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                              <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                              <span v-if="item.label != null">{{$t('order.'+item.label)}}</span>
                              <span v-if="item.label == null">{{$t('order.'+item.name)}}</span>
                            </th>
                            <th scope="col">{{$t('common.action')}}</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-if="dataTable.items.length == 0">
                            <td class="text-center" :colspan="dataTable.fields.length + 1">
                              {{$t('message.no_data')}}
                            </td>
                          </tr>
                          <tr v-for="item in dataTable.items" :key="item.id">
                            <td scope="row" v-for="field in dataTable.fields" :key="field.id" v-show="checkShowByConfig(field.name)">
                              <span v-if="field.render != null" v-html="field.render(item[field.name], item)"></span>
                              <span v-else>{{item[field.name]}}</span>
                            </td>
                            <td scope="row">
                              <div>
                                <b-button variant="primary" class="btn-action-view" @click="showOrderDetail(item.uuid)">
                                  <i class="fa fa-eye" aria-hidden="true"></i> {{$t('order.summary_view')}}</b-button>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />
                      </b-col>
                      <b-col class="text-left">
                        {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                      </b-col>
                      <b-col col lg="1">
                        <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
                      </b-col>
                    </b-row>
                  </b-col>

                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-card header-tag="header" footer-tag="footer">
                <div slot="header">
                  <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('coupon.coupon') }}</strong>
                  <label class="switch switch-sm switch-text switch-info float-right" @click="updateCouponStatus" v-b-toggle.orders_content>
                    <i class="fa fa-sort-down" v-if="couponStatus"></i>
                    <i class="fa fa-sort-up" v-if="!couponStatus"></i>
                  </label>
                </div>
                <b-collapse :visible.sync="couponStatus" id="coupon_content">
                  <b-col cols="12" class="text-center">
                    <!--<b-row>-->
                    <!--<b-col cols="4">-->
                    <!--<div class="pull-left mr-4">-->
                    <!--<b-input-group v-bind:prepend="$t('order.status')">-->
                    <!--<b-form-select v-model="filter.status" v-bind:value="filter.status" :options="statuses[$session.get('lang')]" v-bind:placeholder="$t('order.status')">-->
                    <!--</b-form-select>-->
                    <!--</b-input-group>-->
                    <!--</div>-->
                    <!--</b-col>-->
                    <!--<b-col cols="4">-->
                    <!--<div class="pull-left mr-4">-->
                    <!--<b-input-group v-bind:prepend="$t('order.order_type')">-->
                    <!--<b-form-select v-model="filter.order_type" v-bind:value="filter.order_type" :options="order_types[$session.get('lang')]" v-bind:placeholder="$t('order.order_type')">-->
                    <!--</b-form-select>-->
                    <!--</b-input-group>-->
                    <!--</div>-->
                    <!--</b-col>-->
                    <!--<b-col cols="4">-->
                    <!--<b-input-group>-->
                    <!--<select-dropdown v-bind:options="filter.options" v-bind:selected="filter.selected" position="prepend" v-bind:all="false" v-model="field" prefix="order">-->
                    <!--</select-dropdown>-->
                    <!--<input type="text" class="form-control" v-model="key" v-on:keydown.enter="refreshData"/>-->
                    <!--<div class="input-group-append">-->
                    <!--<b-input-group-append>-->
                    <!--<b-btn @click="refreshData()"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>-->
                    <!--</b-input-group-append>-->
                    <!--</div>-->
                    <!--</b-input-group>-->
                    <!--</b-col>-->
                    <!--</b-row>-->
                    <b-row>
                      <div class="table-responsive">
                        <table class="table table-striped table-hover table-sm header-pointer">
                          <thead>
                          <tr>
                            <th scope="col" v-for="item in couponDataTable.fields" :key="item.id">
                              <i class="fa fa-sort-amount-asc text-muted" v-if="couponDataTable.sort.type == 'asc' && couponDataTable.sort.field == item.name"></i>
                              <i class="fa fa-sort-amount-desc text-muted" v-if="couponDataTable.sort.type == 'desc' && couponDataTable.sort.field == item.name"></i>
                              <span v-if="item.label != null">{{$t('coupon.'+item.label)}}</span>
                              <span v-if="item.label == null">{{$t('coupon.'+item.name)}}</span>
                            </th>
                            <th scope="col">{{$t('common.action')}}</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-if="couponDataTable.items.length == 0">
                            <td class="text-center" :colspan="couponDataTable.fields.length + 1">
                              {{$t('message.no_data')}}
                            </td>
                          </tr>
                          <tr v-for="item in couponDataTable.items" :key="item.id">
                            <td scope="row" v-for="field in couponDataTable.fields" :key="field.id">
                              <img v-if="field.name == 'image'" v-bind:src="field.render(item[field.name], item)" height="80"/>
                              <span v-else-if="field.render != null" v-html="field.render(item[field.name], item)"></span>
                              <span v-else>{{item[field.name]}}</span>
                            </td>
                            <td scope="row">
                              <div>
                                <b-button variant="primary" class="btn-action-view" @click="$router.push({name: 'coupon_edit', params :{id : item.uuid}})">
                                  <i class="fa fa-edit" aria-hidden="true"></i> {{$t('common.edit')}}</b-button>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </b-row>
                    <!--<b-row>-->
                    <!--<b-col>-->
                    <!--<b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />-->
                    <!--</b-col>-->
                    <!--<b-col class="text-left">-->
                    <!--{{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}-->
                    <!--</b-col>-->
                    <!--<b-col col lg="1">-->
                    <!--<b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>-->
                    <!--</b-col>-->
                    <!--</b-row>-->
                  </b-col>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="canViewGamificationTicketsHistory">
            <b-col cols="12">
              <b-card header-tag="header" footer-tag="footer">
                <div slot="header">
                  <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('gamification.tickets_history') }}</strong>
                </div>
                <b-collapse :visible.sync="couponStatus" id="gamification_tickets_history">
                  <b-col cols="12" class="text-center">
                    <b-row>
                      <div class="table-responsive">
                        <table class="table table-striped table-hover table-sm header-pointer">
                          <thead>
                          <tr>
                            <th scope="col" v-for="item in gamificationTicketsHistoryDataTable.fields" :key="item.id">
                              <!-- <i class="fa fa-sort-amount-asc text-muted" v-if="gamificationTicketsHistoryDataTable.sort.type == 'asc' && gamificationTicketsHistoryDataTable.sort.field == item.name"></i>
                              <i class="fa fa-sort-amount-desc text-muted" v-if="gamificationTicketsHistoryDataTable.sort.type == 'desc' && gamificationTicketsHistoryDataTable.sort.field == item.name"></i> -->
                              <span v-if="item.label != null">{{$t('gamification.'+item.label)}}</span>
                              <span v-if="item.label == null">{{$t('gamification.'+item.name)}}</span>
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                            <tr v-if="gamificationTicketsHistoryDataTable.items.length == 0">
                              <td class="text-center" :colspan="gamificationTicketsHistoryDataTable.fields.length + 1">
                                {{$t('message.no_data')}}
                              </td>
                            </tr>
                            <tr v-else v-for="item in gamificationTicketsHistoryDataTable.items" :key="item.id">
                              <td scope="row" v-for="field in gamificationTicketsHistoryDataTable.fields" :key="field.id">
                                <span v-if="field.render != null" v-html="field.render(item[field.name], item)"></span>
                                <span v-else>{{item[field.name]}}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </b-row>
                  </b-col>
                  <b-row>
                      <b-col>
                        <b-pagination :total-rows="gamificationTicketsHistoryDataTable.total" :per-page="gamificationTicketsHistoryDataTable.perPage" v-model="gamificationTicketsHistoryDataTable.currentPage" />
                      </b-col>
                      <b-col class="text-left">
                        {{$t('message.datatable_total', {number: gamificationTicketsHistoryDataTable.items.length, total: gamificationTicketsHistoryDataTable.total})}}
                      </b-col>
                      <b-col col lg="1">
                        <b-form-select v-model="gamificationTicketsHistoryDataTable.perPage" :options="[5, 10, 20, 50, 100]" class="mb-3"/>
                      </b-col>
                    </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <div id="modal_order_detail" class="row" v-if="orderDetail">
      <b-modal class="view-modal-lg" size="huge" v-model="review_model" @ok="review_model = false" :hide-footer="true" :hide-header="true">
        <table class="table table-borderless">
          <thead>
          <tr>
            <th scope="col">{{$t('order.order_number')}}</th>
            <th scope="col">{{$t('order.delivery_address')}}</th>
            <th scope="col">{{$t('order.order_detail')}}</th>
            <th>
              <div class="pull-right" style="margin-top: -48px;margin-right: -1px;">
                <a href="javascript:void(0)" @click="review_model = false" class="close" style="font-size:35px;">&times;</a>
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{orderDetail.order_number}}</td>
            <td><span v-if="orderDetail.order_type == 'D'">{{orderDetail.address}}</span></td>
            <td colspan="2">
              <div class="wrap">
                <div class="blocks">
                  <div v-for="(item,index) in orderDetail.order_items" :key="index+0">{{item.name}}
                    <!-- Type = 0 => Single -->
                    <div v-if="item.type == 0">
                      <div v-for="(sub_item, sub_index) in item.items" :key="sub_index+0">
                        <div class="item-row">
                          <div class="item-name">
                            <strong><span v-if="sub_item.quantity >= 1">{{$t('customer.format_product',{quantity: sub_item.quantity, product: sub_item.name})}} </span> <span v-else>{{sub_item.name}}</span></strong>
                          </div>
                          <div class="item-price"><strong>{{sub_item.total}} ({{currency.symbol}})</strong></div>
                        </div>
                        <div class="item-row" v-if="sub_item.first.uuid != '' && sub_item.first.second.uuid != ''">
                          <div class="option-name">{{sub_item.first.name}} - {{sub_item.first.second.name}}</div>
                          <div class="item-price">{{sub_item.first.price + sub_item.first.second.price}} ({{currency.symbol}})</div>
                        </div>
                        <div class="item-row" v-for="topping in sub_item.topping.extra">
                          <div class="topping-name">{{$t('common.add')}} {{topping.name}}</div>
                          <div class="item-price">{{topping.price * topping.quantity}} ({{currency.symbol}})</div>
                        </div>
                        <div class="item-row" v-for="topping in sub_item.topping.remove">
                          <div class="topping-name">{{$t('common.remove')}} {{topping.name}}</div>
                          <div class="item-price"></div>
                        </div>
                      </div>
                    </div>
                    <!-- Type = 1 => Combo -->
                    <div v-if="item.type == 1">
                      <div class="item-row">
                        <div class="item-name">
                          <strong><span v-if="item.quantity >= 1">{{$t('customer.format_product',{quantity: item.quantity, product: item.name})}}</span><span v-else> {{item.name}}</span></strong>
                        </div>
                        <div class="item-price"><strong>{{item.total}} ({{currency.symbol}})</strong></div>
                      </div>
                      <div v-for="(sub_item, sub_index) in item.items" :key="sub_index+0">
                        <div class="item-row">
                          <div class="item-name">
                            <span v-if="sub_item.quantity >= 1">{{$t('customer.format_product',{quantity: sub_item.quantity, product: sub_item.name})}}</span> <span  v-else>{{sub_item.name}}</span>
                          </div>
                          <div class="item-price">{{sub_item.total}} ({{currency.symbol}})</div>
                        </div>
                        <div class="item-row" v-if="sub_item.first.uuid != '' && sub_item.first.second.uuid != ''">
                          <div class="option-name">{{sub_item.first.name}} - {{sub_item.first.second.name}}</div>
                          <div class="item-price">{{sub_item.first.price + sub_item.first.second.price}} ({{currency.symbol}})</div>
                        </div>
                        <div class="item-row" v-for="topping in sub_item.topping.extra">
                          <div class="topping-name">{{$t('common.add')}} {{topping.name}}</div>
                          <div class="item-price">{{topping.price * topping.quantity}} ({{currency.symbol}})</div>
                        </div>
                        <div class="item-row" v-for="topping in sub_item.topping.remove">
                          <div class="topping-name">{{$t('common.remove')}} {{topping.name}}</div>
                          <div class="item-price"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr v-if="orderDetail.note!=null">

                <div class="blocks" v-if="orderDetail.note!=null">
                  <a class="btn btn-danger btn-xs btn-note">NOTE</a>
                </div>
                <div class="blocks" v-if="orderDetail.note!=null">
                  <li class="li-note">{{orderDetail.note}}</li>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </b-modal>
    </div>
    <div id="modal_edit_customer" class="row">
      <b-modal class="view-modal-lg" size="lg" v-model="edit_customer" @ok="edit_customer = false" :hide-footer="true" :hide-header="true">
        <b-row>
          <b-col cols="12">
            <b-card header-tag="header" footer-tag="footer" class="header mb-0">
              <div slot="header">
              <span>
                <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('category.basic_information') }}</strong>
              </span>
              </div>
              <b-form>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.first_name')}}</legend>
                  <b-form-input type="text"
                                class="form-control border-radius-4px col-sm-9"
                                v-model="customerInfoUpdate.first_name"
                  />
                </div>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.local_first_name')}}</legend>
                  <b-form-input type="text"
                                class="form-control border-radius-4px col-sm-9"
                                v-model="customerInfoUpdate.local_first_name"
                  />
                </div>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.last_name')}}</legend>
                  <b-form-input type="text"
                                class="form-control border-radius-4px col-sm-9"
                                v-model="customerInfoUpdate.last_name"
                  />
                </div>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.local_last_name')}}</legend>
                  <b-form-input type="text"
                                class="form-control border-radius-4px col-sm-9"
                                v-model="customerInfoUpdate.local_last_name"
                  />
                </div>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.email')}}</legend>
                  <div class=" col-sm-9" >
                    <div class="row" v-for="(e, index) in inputEmails" :key="index+0">
                      <b-form-input type="text" class="border-radius-4px col-sm-8" v-model="inputEmails[index].email"  />
                      <span class="col-sm-2 t22 pointer" @click="removeCustomerEmail(index)" v-if="index > 0">
                        <i class="fa fa-trash-o color-red" ></i>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.phone')}}</legend>
                  <b-form-input type="text"
                                class="form-control border-radius-4px col-sm-9"
                                v-model="customerInfoUpdate.phone"
                  />
                </div>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.token_balance')}}</legend>
                  <b-form-input type="number" readonly="readonly"
                                class="form-control border-radius-4px col-sm-9"
                                v-model="customerInfoUpdate.remaining_tickets"
                  />
                </div>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.add_tokens')}}</legend>
                  <b-form-input type="number"
                                class="form-control border-radius-4px col-sm-9"
                                v-model="customerInfoUpdate.add_tickets"
                  />
                </div>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.birthdate')}}</legend>
                  <masked-input
                    type="text"
                    name="date"
                    class="form-control col-sm-6 float-left border-radius-4px col-sm-9"
                    v-model="customerInfoUpdate.birthdate"
                    :mask="[/\d/, /\d/, /\d/, /\d/,'-',/\d/, /\d/, '-', /\d/, /\d/]"
                    :guide="true"
                    placeholderChar="_"
                    :showMask="true"
                    :keepCharPositions="true">
                  </masked-input>
                </div>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.gender')}}</legend>
                  <b-form-select  class="form-control border-radius-4px col-sm-9"
                  v-model="customerInfoUpdate.gender"
                  :options="customerInfoUpdate.customerArrGender[$session.get('lang')]"
                  v-bind:placeholder="$t('customer.gender')" />
                </div>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.prefer_payment')}}</legend>
                  <b-form-select  class="form-control border-radius-4px col-sm-9"
                                  :options="listOfPaymentMethod[$session.get('lang')]"
                                  v-model="customerInfoUpdate.prefer_payment"
                                  v-bind:placeholder="$t('customer.prefer_payment')" />
                </div>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.receive_notification')}} </legend>
                  <div class="custom-control custom-checkbox">
                    <input v-model="customerInfoUpdate.receive_notification" class="checkbox custom-control-input" id="checkbox1" type="checkbox">
                    <label for="checkbox1" class="custom-control-label"></label>
                  </div>
                </div>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.pontaid')}} </legend>
                  <div class="">
                    <label v-if="customerInfoUpdate.ponta">{{customerInfoUpdate.ponta.point_id}}</label>
                  </div>
                </div>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.ponta_point_multiplier')}} </legend>
                  <div class="col-form-label">
                    <label v-if="!customerInfoUpdate.ponta">x1</label>
                    <label v-else-if="customerInfoUpdate.ponta && customerInfoUpdate.ponta.hasOwnProperty('rate')">x{{customerInfoUpdate.ponta.rate}}</label>
                    <label v-else>x1</label>

                  </div>
                </div>

                <!-- for cusomize fields -->
                <div class="form-group row">
                  <customize-field style="position:relative; width:100%;padding-left:15px;" label_cols="3" prefix="customer" :item="config.fields" type="customer" position="before" element="name_seo"></customize-field>
                  <customize-field style="position:relative; width:100%;padding-left:15px;" label_cols="3" prefix="customer" :item="config.fields" type="customer" position="after" element="name_seo"></customize-field>
                </div>
              </b-form>
            </b-card>
        </b-col>
      </b-row>
        <b-row>
          <b-col>
            <button type="button" class="btn border-radius-4px bg-main pull-left" @click="cancelCustomer"><i class="fa fa-times"></i>&nbsp;{{$t('category.close')}}</button>
            <div class="btn-save">
              <button type="button" class="btn border-radius-4px bg-main pull-right" @click="saveCustomer"><i class="fa fa-save"></i>&nbsp; {{$t('common.save')}}</button>
            </div>
          </b-col>
        </b-row>
      </b-modal>
    </div>
    <div id="modal_edit_address" class="row">
      <b-modal class="view-modal-lg" size="lg" v-model="editAddress" @ok="editAddress = false" :hide-footer="true" :hide-header="true">
        <b-row>
          <b-col cols="12">
            <b-card header-tag="header" footer-tag="footer" class="header mb-0">
              <div slot="header">
              <span>
                <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('category.basic_information') }}</strong>
              </span>
              </div>
              <b-form>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.house_no')}}</legend>
                  <b-form-input type="text"
                                class="form-control border-radius-4px col-sm-9"
                                v-model="customerAddressSelected.house_no"
                  />
                </div>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.landmark')}}</legend>
                  <b-form-input type="text"
                                class="form-control border-radius-4px col-sm-9"
                                v-model="customerAddressSelected.landmark"
                  />
                </div>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.unit_no')}}</legend>
                  <b-form-input type="text"
                                class="form-control border-radius-4px col-sm-9"
                                v-model="customerAddressSelected.unit_no"
                  />
                </div>
              </b-form>
            </b-card>
        </b-col>
      </b-row>
        <b-row>
          <b-col>
            <button type="button" class="btn border-radius-4px bg-main pull-left" @click="cancelUpdateAddress"><i class="fa fa-times"></i>&nbsp;{{$t('category.close')}}</button>
            <div class="btn-save">
              <button type="button" class="btn border-radius-4px bg-main pull-right" @click="updateAddress(customerAddressSelected)"><i class="fa fa-save"></i>&nbsp; {{$t('common.save')}}</button>
            </div>
          </b-col>
        </b-row>
      </b-modal>
    </div>
    <div id="modal_edit_membership" class="row">
      <b-modal class="view-modal-lg" size="lg" v-model="edit_member_ship" @ok="edit_member_ship = false" :hide-footer="true" :hide-header="true">
        <b-row>
          <b-col cols="12">
            <b-card header-tag="header" footer-tag="footer" class="header mb-0">
              <div slot="header">
              <span>
                <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('category.basic_information') }}</strong>
              </span>
              </div>
              <b-form>
                <div class="form-group row">
                  <legend class="col-sm-3 col-form-label">{{$t('customer.member_ship')}}</legend>
                  <b-form-select  class="form-control border-radius-4px col-sm-9"
                                  v-model="membership"
                                  :options="listMemberShip"
                                  v-bind:placeholder="$t('customer.gender')" />
                </div>
              </b-form>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <button type="button" class="btn border-radius-4px bg-main pull-left" @click="cancelMemberShip"><i class="fa fa-times"></i>&nbsp;{{$t('category.close')}}</button>
            <div class="btn-save">
              <button type="button" class="btn border-radius-4px bg-main pull-right" @click="saveMemberShip"><i class="fa fa-save"></i>&nbsp; {{$t('common.save')}}</button>
            </div>
          </b-col>
        </b-row>
      </b-modal>
    </div>
    <b-modal :title="$t('customer.confirm_delete_title')" class="view-modal-lg" size="huge" ref="deleteCustomer" :ok-title="$t('common.yes')" :cancel-title="$t('common.cancel')" :ok="disableCustomer">
      <p>{{$t('customer.confirm_delete_content')}}</p>
    </b-modal>
                                            <!-- Modal Assign Coupon -->
    <div id="modal_assignCoupon" class="row">
      <b-modal class="view-modal-lg" size="lg" v-model="assignCoupon" @ok="assignCoupon = false" :hide-footer="true" :hide-header="true">
        <b-row>
          <b-col cols="12">
            <b-card header-tag="header" footer-tag="footer" class="header mb-0">
              <div slot="header">
              <span>
                <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('category.basic_information') }}</strong>
              </span>
              </div>
              <b-form>
                <b-form-group v-bind:label="$t('customer.coupon')" :label-cols="2" :horizontal="true">
                      <multiselect
                      class="border-radius-4px"
                      v-model="coupon"
                      v-bind:placeholder="$t('customer.place_holder_select_coupon')"
                      label="text"
                      track-by="value"
                      :options="listAvailableCoupon.hasOwnProperty($session.get('lang')) ?  listAvailableCoupon[$session.get('lang')] : []"
                      :multiple="false"
                      v-bind:selectLabel="$t('menu.select_label')"
                      v-bind:deselectLabel="$t('menu.select_remove')"
                      v-bind:selectedLabel="$t('menu.selected')"
                    >
                    </multiselect>
                </b-form-group>
              </b-form>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <button type="button" class="btn border-radius-4px bg-main pull-left" @click="assignCoupon = false"><i class="fa fa-times"></i>&nbsp;{{$t('category.close')}}</button>
            <div class="btn-save">
              <button type="button" class="btn border-radius-4px bg-main pull-right" @click="assignCouponToCustomer"><i class="fa fa-save"></i>&nbsp; {{$t('common.save')}}</button>
            </div>
          </b-col>
        </b-row>
      </b-modal>
    </div>
  </div>
</template>
<script>
  import SelectDropdown from '../../../components/Partials/SelectDropdown'
  import DataTable from '../../../components/Partials/DataTable'
  import axios from 'axios'
  // import BCol from "bootstrap-vue/src/components/layout/col";
  import MaskedInput from 'vue-text-mask'
  import Multiselect from 'vue-multiselect'
  import moment from 'moment'
  import CustomizeField from '../../../components/Partials/CustomizeField'
  import Vue from 'vue'
  import VueJsonToCsv from 'vue-json-to-csv'


Vue.component('VueJsonToCsv', VueJsonToCsv)

  const CancelToken = axios.CancelToken
  let cancel = null
  let vm = null
  export default {
    name: 'CustomerDetailList',
    components: {
      // BCol,
      SelectDropdown,
      DataTable,
      MaskedInput,
      Multiselect,
      CustomizeField
    },
    props: {
      cid: {
        required: true
      }
    },
    data: function () {
      return {
        useApiV4: false,
        clientTimezone: null,
        canViewGamificationTicketsHistory:
          this.$auth.user().user_info.user.permissions.includes('get.v1.gamification.history'),
        inputEmails: [],
        customerInfoUpdate: {
          customerArrGender: {},
        },
        currency: this.$store.getters.config.gms.currency_info,
        config: this.$store.getters.config.gms.customer,
        basicInformationStatus: true,
        locationStatus: true,
        ordersStatus: true,
        couponStatus : true,
        order: this.$store.getters.config.gms.order,
        orderDetail: {},
        review_model: false,
        field: null,
        key: null,
        customerAddressSelected: {
        },
        customerInfo: {
          ponta: {},
          customerArrGender: {},
          gender: 'M',
          prefer_payment: 'cash'
        },
        type: 'like',
        statuses: [],
        order_types: [],
        late_delivery_statuses: [],
        filter: {
          options: [],
          selected: null,
          status: '',
          order_type: '',
          code: '',
          late_delivery: ''
        },
        dataTable: {
          items: [],
          fields: [
            {
              name: 'order_status',
              label: 'status', // phils,japan
              filter: false,
              sort: false,
              render: (data, row) => {
                if (data == null) return ''
                return this.$t('order.order_status_' + data.id)
              }
            },
            {
              name: 'order_number', // phils,japan,sing
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'order_type', // phils,japan,sing
              filter: false,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                let type
                if (data == 'D') {
                  type = vm.$t('common.delivery')
                }
                if (data == 'C') {
                  type = vm.$t('common.takeaway')
                }
                return type
              }
            },
            {
              name: 'outlet_name', // phils,japan
              filter: false,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return row.outlet_code + '  ' + data
              }
            },
            {
              name: 'sale_channel', // phils,japan
              filter: false,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'payment_method', // phils,japan
              filter: false,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'total', // phils,japan
              filter: false,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return new Intl.NumberFormat().format(data) + ' ' + this.$t('order.'+row.currency)
              }
            },
            {
              name: 'store_delivery_address', // sing
              filter: false,
              sort: false,
              render: (data, row) => {
                return row.outlet_address + ', #' + row.address
              }
            },
            {
              name: 'eios_sending_log', // sing
              filter: false,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return row.outlet_code + '  ' + data
              }
            },
            {
              name: 'created_at', // phils,japan
              filter: false,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                let timezone = row.outlet_timezone
                return this.convertUTCToTimeZone(data, timezone) ? this.convertUTCToTimeZone(data, timezone).format('YYYY-MM-DD HH:mm:ss') : data
              }
            },
            {
              name: 'show_late_delivery', //Japan
              filter: false,
              sort: false,
              render: (data, row) => {
                if (row.order_type !== 'D') {
                  return ''
                }
                return vm._.get(row.customize, 'is_late_delivery', 0) == 1 ? vm.$t('common.yes') : vm.$t('common.no')
              }
            },
            {
              name: 'collection_time', // phils,japan
              filter: false,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                let timezone = row.outlet_timezone
                return this.convertUTCToTimeZone(data, timezone) ? this.convertUTCToTimeZone(data, timezone).format('YYYY-MM-DD HH:mm:ss') : data
              }
            },
            {
              name: 'assigned', // phils,japan
              filter: false,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data.name
              }
            }
          ],
          sort: {
            field: 'updated_at',
            type: 'desc'
          },
          currentPage: 1,
          total: 0,
          perPage: 10,
          source: null
        },
        item: {},
        couponDataTable : {
          items: [],
          fields: [
            {
              name: 'code', // sing
              filter: false,
              sort: false,
              render: (data, row) => {
                return row.code
              }
            },
            {
              name: 'name', // sing
              filter: false,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return row.name[vm.$session.get('lang')]
              }
            },
            {
              name: 'content', // phils,japan
              filter: false,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return row.content[vm.$session.get('lang')]
              }
            },
            {
              name: 'image', // phils,japan
              filter: false,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return this.getImage(row)
              }
            },
            {
              name: 'expired_from', // phils,japan
              filter: false,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'expired_to', // phils,japan
              filter: false,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            }
          ],
          sort: {
            field: 'expired_from',
            type: 'desc'
          },
          currentPage: 1,
          total: 0,
          perPage: 100,
          source: null
        },
        gamificationTicketsHistoryDataTable: {
          items: [],
          fields: [
            {
              name: 'usage_type',
              filter: false,
              sort: false,
              render: (data, row) => {
                return row.usage_type
              }
            },
            {
              name: 'tickets',
              filter: false,
              sort: false,
              render: (data, row) => {
                return row.tickets
              }
            },
            {
              name: 'created_at',
              filter: false,
              sort: false,
              render: (data, row) => {
                if (this.clientTimezone) {
                  return moment.unix(row.created_at).tz(this.clientTimezone).format('YYYY-MM-DD HH:mm:ss')
                } else {
                  return moment.unix(row.created_at).format()
                }
              }
            }
          ],
          sort: {
            field: 'created_at',
            type: 'desc'
          },
          currentPage: 1,
          total: 0,
          perPage: 10,
          source: null
        },
        editAddress : false,
        edit_customer : false,
        edit_member_ship : false,
        listMemberShip : [],
        listOfPaymentMethod : {},
        membership : '',
        currentMembershipName: null,
        assignCoupon : false,
        listAvailableCoupon : {},
        coupon : '',
        COUPON_TYPES: {
          PROMOTION: [4, 5, 6],
          DISCOUNT: [2, 3],
          FREE_GIFT: [1],
          CIRCLE_DISCOUNT: [5]
        },
        COUPON_IMAGES: {
          PROMOTION: {
            JA: 'https://static.pizzahut.jp/jp/images/Promotion-JP.jpg',
            EN: 'https://static.pizzahut.jp/jp/images/Promotions.png'
          },
          DISCOUNT: {
            JA: 'https://static.pizzahut.jp/jp/images/Discount-JP.jpg',
            EN: 'https://static.pizzahut.jp/jp/images/Discount.png'
          },
          FREE_GIFT: {
            JA: 'https://static.pizzahut.jp/jp/images/Free-Gift-JP.jpg',
            EN: 'https://static.pizzahut.jp/jp/images/Free Gift.png'
          }
        },
        exportCustomerBasicInfoToCSV:{
          data:[],
          fileName:"",
          fields:{
            first_name:{title:this.$t('customer.first_name')},
            last_name:{title : this.$t('customer.last_name')},
            email:{title : this.$t('customer.email')},
            phone:{title : this.$t('customer.phone')},
            birthdate:{title : this.$t('customer.birthdate')},
            gender:{title : this.$t('customer.gender')},
            receive_html_mail:{title : this.$t('customer.receive_notification')},
            tax_id:{title : this.$t('customer.tax_id')},
            
          }
        },
        exportOrdersToCSV:{
          data:[],
          totalOrdersCount:-1,
          fileName:"",
          fields:{
            first_name:{title:this.$t('order.first_name')},
            last_name:{title : this.$t('order.last_name')},
            email:{title : this.$t('order.email')},
            phone:{title : this.$t('order.phone')},
            birthdate:{title : this.$t('order.birthdate')},
            gender:{title : this.$t('order.gender')},
            receive_html_mail:{title : this.$t('order.receive_notification')},
            tax_id:{title : this.$t('order.tax_id')},
            order_status:{title: this.$t('order.order_status')},
            order_number:{title:this.$t('order.order_number')},
            order_type:{title : this.$t('order.order_type')},
            outlet_name:{title : this.$t('order.outlet_name')},
            payment_method:{title : this.$t('order.payment_method')},
            total:{title : this.$t('order.total')},
            store_delivery_address:{title : this.$t('order.store_delivery_address')},
            created_at:{title : this.$t('order.created_at')},
            collection_time:{title : this.$t('order.collection_time')}        
          }
        },
        exportCouponsToCSV:{
          data:[],
          fileName:"CouponsDetails",
          fields:{
            code:{title:this.$t('coupon.code')},
            name:{title:this.$t('code.name')},
            content:{title : this.$t('code.content')},
            //image:{title : this.$t('order.order_number')},
            expired_from:{title : this.$t('code.expired_from')},
            expired_to:{title : this.$t('order.expired_to')}            
          }
        },
        exportShippingAddressToCSV:{
          data:[],
          fileName:"ShippingAddressDetails",
          fields:{
            display_address:{title : this.$t('customer.display_address')},
            location:{title : this.$t('customer.location')},
            name:{title : this.$t('customer.name')},
            landmark:{title : this.$t('customer.landmark')},
            house_no:{title : this.$t('customer.house_no')},
            unit_no:{title : this.$t('customer.unit_no')},
            zip_code:{title : this.$t('customer.zip_code')},            
          }
        },
        listAvailaleCouponsWithLang : []
      }      
    },
    methods: {
      removeCustomerEmail (index) {
        delete this.inputEmails[index]
        let data = []
        for (let i in this.inputEmails) {
          if (i != index) {
            data.push(this.inputEmails[i])
          }
        }
        this.inputEmails = data
      },
      /**
       * update status of customise session
       */
      updateBasicInformationStatus () {
        this.basicInformationStatus = !this.basicInformationStatus
      },
      updateLocationStatus () {
        this.locationStatus = !this.locationStatus
      },
      updateOrdersStatus () {
        this.ordersStatus = !this.ordersStatus
      },
      updateCouponStatus () {
        this.couponStatus = !this.couponStatus
      },
      checkShowByConfig (key) {
        if (this.order == null) {
          return true
        }
        let config = this._.find(this.order.list, function (o) {
          return o.type === key
        })
        if (config == null) {
          return false
        }
        return config.show
      },
      showOrderDetail (uuid) {
        let app = this
        app.review_model = true
        app.axios.order.getOrderDetail(uuid,
          function (response) {
            app.orderDetail = response.data.data.item
          })
      },
      updateSort: function (field) {
        for (let i in this.dataTable.fields) {
          if (this.dataTable.fields[i].name == field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort == false)) {
            return
          }
        }
        if (this.dataTable.sort.field != field) {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        } else {
          if (this.dataTable.sort.type == 'asc') {
            this.dataTable.sort = {
              field: field,
              type: 'desc'
            }
          } else {
            this.dataTable.sort = {
              field: field,
              type: 'asc'
            }
          }
        }

        this.refreshData()
      },
      refreshGamificationTicketsHistoryData: function () {
        this.getGamificationTicketsHistory()
      },
      /**
       * Refesh data
       */
      refreshData: function () {
        if (cancel != null) {
          cancel()
        }
        let search = ''
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          search = '&' + this.field + '=' + this.key.trim()
        }
        if (this.filter.status != '') {
          search = search + '&status=' + this.filter.status
        }
        if (this.filter.order_type != '') {
          search = search + '&order_type=' + this.filter.order_type
        }

        if (this.filter.late_delivery !== '') {
          search = search + '&late_delivery=' + this.filter.late_delivery
        }

        let params = '?user_id=' + this.cid + '&limit=' + this.dataTable.perPage + '&page=' + this.dataTable.currentPage + '&sort_by=' + this.dataTable.sort.field + '&order_by=' + this.dataTable.sort.type + search
        this.axios.order.getOrderList(params, {
          cancelToken: new CancelToken(function executor (c) {
            cancel = c
          })
        },
        function (response) {
          let langs = Object.keys(vm.$i18n.messages)
          for (let l in langs) {
            vm.statuses[langs[l]] = [
              {text: vm.$t('common.all', langs[l]), value: ''},
              {text: vm.$t('order-phil.pending', langs[l]), value: '0'},
              {text: vm.$t('order-phil.complete', langs[l]), value: 1},
              {text: vm.$t('order-phil.processing', langs[l]), value: 2},
              {text: vm.$t('order-phil.cooking', langs[l]), value: 3},
              {text: vm.$t('order-phil.delivery', langs[l]), value: 4},
              {text: vm.$t('order-phil.cancel', langs[l]), value: 5},
              {text: vm.$t('order-phil.return', langs[l]), value: 6},
              {text: vm.$t('order-phil.error', langs[l]), value: 7}
            ]
            vm.dataTable.items = response.data.data.items
            vm.dataTable.total = response.data.data.pagination.total
            vm.exportOrdersToCSV.totalOrdersCount = response.data.data.pagination.total;            
          }
        },
        function (error) {
          console.log('error:' + error)
        })
      },
      getAllOrdersAndDownloadAsCSV(){
        if (cancel != null) {
          cancel()
        }
        let search = ''
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          search = '&' + this.field + '=' + this.key.trim()
        }
        if (this.filter.status != '') {
          search = search + '&status=' + this.filter.status
        }
        if (this.filter.order_type != '') {
          search = search + '&order_type=' + this.filter.order_type
        }

        let params = '?user_id=' + this.cid + '&limit=' + this.exportOrdersToCSV.totalOrdersCount + '&sort_by=' + this.dataTable.sort.field + '&order_by=' + this.dataTable.sort.type + search
       
        this.axios.order.getOrderList(params, {
          cancelToken: new CancelToken(function executor (c) {
            cancel = c
          })
        },function(response){
          vm.exportOrdersToCSV.data = response.data.data.items;
          vm.export_All_data();
        },function (error){
            console.log('error:' + error)
        });
      },
      /**
       * Get customer detail
       */
      getDetail () {
        let params = {'id': this.cid}
        this.axios.customer.getCustomerDetail(
          params,
          function (response) {
            response.data.data.item.customerArrGender = {}

            vm.mapDataDetail(response.data.data.item)
          },
          function (error) {
            this.$router.push({name: 'customers'})
          },
          {
            useApiV4: this.useApiV4,
          }
        )
      },
      mapDataDetail (data) {
        const { locations = [] } = data
        let indexLimitedLocalization = 0;
        let displayAddress = '';
        this.customerInfo = data

        this.customerInfo.locations = locations.map((item = {}) => {
          displayAddress = item.display_address || '';
          indexLimitedLocalization = displayAddress.indexOf(' - ') || displayAddress.length -1;
          item.localization_address = displayAddress.substring(0, indexLimitedLocalization + 3)
          return item;
        })
        for (let l in vm.$store.getters.languages) {
          let lang = this.$store.getters.languages[l]
          this.customerInfo.customerArrGender[lang] = [{text: this.$t('customer.male', lang), value: 'M'}, {text: this.$t('customer.female', lang), value: 'F'}]
        }
      },
      getListPayment(){
        this.axios.payment.getPaymentSimpleListGMS(function(response){
          for (let l in vm.$store.getters.languages) {
            let lang = vm.$store.getters.languages[l]
            vm.listOfPaymentMethod[lang] = []
            for (let i in response.data.data.items) {
              vm.listOfPaymentMethod[lang].push({text: response.data.data.items[i].display_name[lang], value: response.data.data.items[i].code})
            }
          }
        })
      },
      getGamificationTicketsHistory(){
        if (this.canViewGamificationTicketsHistory) {
          this.axios.customer.getGamificationTicketsHistory({
            cid: this.cid,
            page: this.gamificationTicketsHistoryDataTable.currentPage,
            limit: this.gamificationTicketsHistoryDataTable.perPage
          },
            function (response) {
              vm.gamificationTicketsHistoryDataTable.items = response.data.data.items
              vm.gamificationTicketsHistoryDataTable.currentPage = response.data._metadata.page
              vm.gamificationTicketsHistoryDataTable.perPage = response.data._metadata.limit
              vm.gamificationTicketsHistoryDataTable.total = response.data._metadata.total
            },
            function (error) {})
        }
      },
      getCouponDetails(){
        let params = '?customer_id='+this.cid+'&current_date=' + moment().format('YYYY-MM-DD')
        this.axios.customer.getCouponDetailForUser(params,
          function (response) {
            vm.couponDataTable.items = response.data.data.items
          },
          function (error) {
            this.$router.push({name: 'customers'})
          })
      },
      editCustomer(){
        this.customerInfoUpdate = this._.cloneDeep(this.customerInfo)
        this.inputEmails = this._.cloneDeep(this.customerInfo.emails)
        this.edit_customer = true
      },
      editAddressPopup(data) {
        this.editAddress = true
        this.customerAddressSelected = data
      },
      updateAddress(data){
        let params = {}
        let locationSplit = data.display_address.split(' - ');
        let newLocation = locationSplit[0] + ' - ' + data.house_no + ' ' + data.landmark + ' ' + data.unit_no
        // console.log(newLocation);
        vm.isProcessing = true
        params.id = data.id
        params.house_no = data.house_no
        params.landmark = data.landmark
        params.unit_no = data.unit_no
        params.location = newLocation
        vm.axios.customer.updateAddressCustomerProfile(params,
        function (response) {
          vm.isProcessing = false
          vm.getDetail()
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        },
        function (callBackError) {
          vm.isProcessing = false
        })
        vm.editAddress = false
      },
      saveCustomer(){
        let params = {}
        vm.isProcessing = true
        params.id = vm.cid
        params.email = vm.customerInfoUpdate.email
        params.add_tickets = vm.customerInfoUpdate.add_tickets
        params.emails = []
        params.emails = this._.map(this.inputEmails, 'email')
        params.first_name = vm.customerInfoUpdate.first_name
        params.local_first_name = vm.customerInfoUpdate.local_first_name
        params.last_name = vm.customerInfoUpdate.last_name
        params.local_last_name = vm.customerInfoUpdate.local_last_name
        params.phone = vm.customerInfoUpdate.phone
        params.prefer_payment = vm.customerInfoUpdate.prefer_payment
        params.gender = vm.customerInfoUpdate.gender
        params.receive_notification = vm.customerInfoUpdate.receive_notification ? 1 : 0

        if (moment(vm.customerInfoUpdate.birthdate, 'YYYY-MM-DD').isValid()) {
          params.birthdate = vm.customerInfoUpdate.birthdate
        }

        vm.axios.customer.updateCustomerProfile(params,
        function (response) {
          response.data.data.item.customerArrGender = {}
          vm.mapDataDetail(response.data.data.item)
          vm.isProcessing = false
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        },
        function (callBackError) {
          vm.isProcessing = false
        })
        vm.edit_customer = false
      },
      cancelCustomer(){
        vm.edit_customer = false
      },
      getListMemberShip(){
        this.axios.customer.getMemberShip(function (response) {
          for(let i of response.data.data.items){
            vm.listMemberShip.push({'text': vm.convertMemberNameMemberShip(i),'value':i.id})
          }
        })
      },
      convertMemberNameMemberShip(data) {
        let text = '[______]'
        if (data) {
          if (data.hasOwnProperty('name') && data.name) {
            try {
              let lang = vm.$session.get('lang') == 'ja' ? 'ja' : vm.$session.get('lang')
              let obj = typeof data.name === 'string' ? JSON.parse(data.name) : data.name
              text = obj[lang]
            } catch (error) { }
          }
        }
        return text
      },
      editMemberShip(){
        this.edit_member_ship = true
      },
      cancelMemberShip(){
        this.edit_member_ship = false
      },
      cancelUpdateAddress(){
        this.editAddress = false
      },
      saveMemberShip(){
        let params = {}
        vm.isProcessing = true
        params.membership_id = this.membership
        params.id = this.cid
        this.axios.customer.saveMemberShipOfCustomer(params,function (response) {
          vm.isProcessing = false
          vm.getDetail()
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        },
        function (callBackError) {
          vm.isProcessing = false
        })
        this.edit_member_ship = false
      },
      getMemberShipCustomer(){
        let params = {}
        params.id = this.cid
        this.axios.customer.getMemberShipOfCustomer(params,function (response) {
          vm.membership = response.data.data.item.membership_id
          vm.currentMembershipName = response.data.data.item.membership
        })
      },
      enableCustomer () {
        vm.isProcessing = true
        let params = {
          id: vm.cid,
          status: 1
        }
        vm.axios.customer.disableCustomer(params,function (response) {
          vm.isProcessing = false
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
          vm.$router.push({name: 'customers'})
        },
        function () {
          vm.isProcessing = false
        })
      },
      disableCustomer(){
        let options = {
          html: true,
          okText: vm.$t('common.yes'),
          cancelText: vm.$t('common.keepit')
        }
        vm.$dialog.confirm(vm.$t('customer.confirm_delete_content'), options)
          .then(function (dialog) {
            vm.isProcessing = true
            let params = {
              id : vm.cid,
              status : 0
            }
            vm.axios.customer.disableCustomer(params,function (response) {
              vm.isProcessing = false
              vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
              vm.$router.push({name: 'customers'})
            },
            function () {
              vm.isProcessing = false
            })
          })
          .catch(function () {
          })
      },
      deleteCustomer(){
        let options = {
          html: true,
          okText: vm.$t('common.yes'),
          cancelText: vm.$t('common.keepit')
        }
        vm.$dialog.confirm(vm.$t('customer.confirm_delete_content'), options)
          .then(function (dialog) {
            vm.isProcessing = true
            let params = {
              id: vm.customerInfo.uuid
            }

            // BR market: replace all customer-identifiable information, but don't delete
            if (vm.customerInfo.client == 126) {
              const purgedName = `deleted-${vm.customerInfo.uuid}`
              let params = {}
              vm.isProcessing = true
              params.birthdate = vm.customerInfo.birthdate
              params.email = `${purgedName}@pizzahut.io`
              params.emails = [`${purgedName}@pizzahut.io`]
              params.first_name = purgedName
              params.gender = vm.customerInfo.gender
              params.id = vm.cid
              params.last_name = purgedName
              params.local_first_name = null
              params.local_last_name = null
              params.phone = '55555555555'
              params.prefer_payment = null
              params.receive_notification = 0
              params.tax_id = `http418`

              vm.axios.customer.updateCustomerProfile(params,
              function (response) {
                response.data.data.item.customerArrGender = {}
                vm.mapDataDetail(response.data.data.item)
                vm.isProcessing = false
                vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
              },
              function (callBackError) {
                vm.isProcessing = false
              })
            } else {
              // Other markets: delete customer
              vm.axios.customer.deleteCustomer(params,function (response) {
                vm.isProcessing = false
                vm.$toastr.success(vm.$t('message.delete_successful'), vm.$t('message.success'), {})
                vm.$router.push({name: 'customers'})
              },
              function () {
                vm.isProcessing = false
              })
            }
          })
          .catch(function () {
          })
      },
      listOfAssignCoupon(){
        const params = '?current_date=' + moment().format('YYYY-MM-DD')
        this.axios.coupon.getListAssignCoupon(
          params,
          function (response) {
              for (let l in vm.$store.getters.languages) {
                let lang = vm.$store.getters.languages[l]
                vm.listAvailableCoupon[lang] = []                
                for(let i of response.data.data.items){
                  let name =  i.code + " - " + i.name[lang]
                  vm.listAvailableCoupon[lang].push({text: name , value: i.code})
                  vm.listAvailaleCouponsWithLang.push({text: name , value: i.code,lang:lang});
                }
            }
          },
          function (error) {
            console.log(error)
          })
      },
      assign_coupon(){
        this.assignCoupon = true
      },
      export_customer_data(){
        this.getAllOrdersAndDownloadAsCSV();
      },
      export_All_data(){
        if(this.exportOrdersToCSV.totalOrdersCount > 0) {
          this.export_Orders();
          setTimeout(()=>{
              this.$refs.orderElement.handleClick();
          })
        } else {
          this.export_BasicDetails();
          setTimeout(()=>{
              this.$refs.basicInfoElement.handleClick();
        })
        }
        //this.export_ShippingAddress();       
        //this.export_Coupons();

        // setTimeout(()=>{
              //this.$refs.shippingAddressElement.handleClick();
              //this.$refs.couponElement.handleClick();
        // });
        
      },
      export_BasicDetails(){
        this.exportCustomerdata = true;        
        
        let customerDetails = {... this.customerInfo};
        customerDetails.receive_html_mail = customerDetails.receive_html_mail == 0 ? false : true; 
        this.exportCustomerBasicInfoToCSV.data = [customerDetails];
      },
      export_ShippingAddress(){
        this.exportShippingAddressToCSV.data = [...this.customerInfo.locations];
      },
      export_Orders(){
      let fieldsConfig = {};
      vm.dataTable.fields.forEach((orderField) => {
        let isShowField =  this.checkShowByConfig(orderField.name);
        if(isShowField){
          fieldsConfig[orderField.name] = orderField;
        }
      });
      
      this.exportOrdersToCSV.data.map(item => {
        item.first_name = this.customerInfo.first_name;
        item.last_name = this.customerInfo.last_name;
        item.birthdate = this.customerInfo.birthdate;
        item.gender = this.customerInfo.gender;
        item.receive_html_mail = this.customerInfo.receive_html_mail == 0 ? false : true;
        Object.keys(this.exportOrdersToCSV.fields).forEach(csvField =>{
          let field = fieldsConfig[csvField]
          if(field){
            item[csvField] = field.render(item[csvField], item)
          }
        });
      });

      },
      export_Coupons(){
         //let couponDetails = [... vm.listAvailableCoupon ];
        this.exportCouponsToCSV.data = [... vm.couponDataTable.items]
        //customerDetails.coupon =
      },
      assignCouponToCustomer(){
        let params = {
          code : this.coupon.value,
          customer_id : this.cid,
          current_date: moment().format('YYYY-MM-DD')
        }

        vm.isProcessing = true
        this.axios.coupon.assignCoupon(params,
        function (response) {
          vm.isProcessing = false
          vm.getCouponDetails()
          vm.assignCoupon = false
          vm.coupon = ''
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        },
        function (error) {
          vm.isProcessing = false
          console.log(error)
        })
      },
      getImage(item) {
        if (item.image) {
          let la = this.$session.get('lang') || 'en'
          la = la.toUpperCase()
          if (this.COUPON_TYPES.DISCOUNT.includes(item.coupon_type_id)) {
            return this.COUPON_IMAGES.DISCOUNT[la];
          } else if (this.COUPON_TYPES.FREE_GIFT.includes(item.coupon_type_id)) {
            return this.COUPON_IMAGES.FREE_GIFT[la];
          } else {
            return this.COUPON_IMAGES.PROMOTION[la];
          }
        } else {
          return item.image.desktop
        }
      }
    },
    created: function () {
      this.useApiV4 = this.$const.USE_CUSTOMER_API_V4.includes(String(localStorage.getItem('clientID')))

      this.getDetail()
      this.getCouponDetails()
      this.getListMemberShip()
      this.getMemberShipCustomer()
      this.listOfAssignCoupon()
      this.getListPayment()
      this.getGamificationTicketsHistory()

      vm = this
      let CancelToken = vm.axios.CancelToken
      this.dataTable.source = CancelToken.source()

      for (let i in this.dataTable.fields) {
        if (this.dataTable.fields[i].filter != null && this.dataTable.fields[i].filter == true && this.checkShowByConfig(this.dataTable.fields[i].name)) {
          this.filter.options.push(this.dataTable.fields[i])
        }
        if (this.dataTable.fields[i].sort != null && this.dataTable.fields[i].sort == true && this.dataTable.sort.field == null) {
          this.dataTable.sort = {
            field: 'created_at',
            type: 'desc'
          }
        }
      }

      let langs = Object.keys(vm.$i18n.messages)
      for (let l in langs) {
        vm.order_types[langs[l]] = [
          {text: vm.$t('common.all', langs[l]), value: ''},
          {text: vm.$t('common.delivery', langs[l]), value: 'D'},
          {text: vm.$t('common.takeaway', langs[l]), value: 'C'}
        ]
      }
      for (let l in langs) {
        vm.late_delivery_statuses[langs[l]] = [
          {text: vm.$t('common.all', langs[l]), value: ''},
          {text: vm.$t('common.yes', langs[l]), value: 1},
          {text: vm.$t('common.no', langs[l]), value: 0}
        ]
      }

      vm.clientTimezone = vm.client_tz[vm.$session.get('config').country_code.toLowerCase()]
      vm.refreshData()
    },
    watch: {
      'dataTable.currentPage': function (val) {
        this.refreshData()
      },
      'dataTable.perPage': function (val) {
        this.refreshData()
      },
      'gamificationTicketsHistoryDataTable.currentPage': function (val) {
        this.refreshGamificationTicketsHistoryData()
      },
      'gamificationTicketsHistoryDataTable.perPage': function (val) {
        this.refreshGamificationTicketsHistoryData()
      },
      'filter.status': function (val) {
        this.refreshData()
      },
      'filter.code': function (val) {
        this.refreshData()
      },
      'filter.order_type': function (val) {
        this.refreshData()
      },
      'filter.late_delivery': function (val) {
        this.refreshData()
      }
    }
  }
</script>
<style scoped>
  .t22 {
    font-size: 22px;
  }
  .custom-control-input {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }
  input[type="checkbox"] {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0;
  }
  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #0091ff !important;
    border-radius: 3px !important;
  }
  .custom-control-label::before {
    border-radius: 3px !important;
  }
</style>
<style scoped>
  .text-profile {
    font-weight: 500;
    font-size: 17px;
  }
  .bold {
    font-weight: bold;
  }
  strong {
    font-weight: 600;
  }
</style>
<style>
  .order-details {
    width: 100%;
  }
  .order-details .item-row {
    line-height: 25px;
    width: 100%;
    clear: both;
  }
  .order-details .item-name {
    width: 70%;
    font-weight: 600;
    float: left;
  }
  .order-details .option-name {
    padding-left: 10px;
    width: 70%;
    float: left;
  }
  .order-details .topping-name {
    padding-left: 10px;
    width: 70%;
    float: left;
  }
  .order-details .item-price {
    width: 30%;
    float: left;
    text-align: right;
  }
  .customer-profile div.row{
    margin-top: 10px;
  }
  .btn-action-view{min-width: 131px;}
  .btn-edit-cancel{min-width: 82px;}

  .view-modal-lg table.table-borderless > tbody > tr > td,
  .view-modal-lg table.table-borderless > tbody > tr > th,
  .view-modal-lg table.table-borderless > tfoot > tr > td,
  .view-modal-lg table.table-borderless > tfoot > tr > th,
  .view-modal-lg table.table-borderless > thead > tr > td,
  .view-modal-lg table.table-borderless > thead > tr > th {
    border: none;
    line-height: 40px;
    border-bottom: 1px #d1d4d7 solid;
    padding: 0px;
  }

  .modal .modal-huge {
    max-width: 1200px;
    width: 1200px;
  }

  .modal .modal-huge-extra {
    max-width: 1200px;
    width: 1200px;
  }
  .btn-note {border-radius: 5px;}
</style>
<style scoped>
  .customer-profile .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .pdfobject-container { height: 75rem; border: 1rem solid rgba(0,0,0,.1); }
  .pointer{
    cursor: pointer;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .form-check-required.is-invalid ~ .invalid-feedback {
    display: block;
  }

  .form-check-required.is-invalid {
    border: 1px solid #f86c6b
  }

  .multiselect__option--selected.multiselect__option--highlight {
    background-color: #41b883 !important;
  }

  .multiselect__tags {
    border: 1px solid #BABFD8 !important;
  }

  .form-check-required.is-invalid .multiselect__tags {
    border: none !important;
  }

  .multiselect__single {
    font-size: 15px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/customer/Detail.vue